import { render } from "./EditNote.vue?vue&type=template&id=4abf45d0"
import script from "./EditNote.vue?vue&type=script&lang=js"
export * from "./EditNote.vue?vue&type=script&lang=js"

import "./EditNote.vue?vue&type=style&index=0&id=4abf45d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__